import { useContext, useEffect } from "react";
import "../styles/LanguageList.css";
import MainLogoContainer from "../components/MainLogoContainer";
import MainContainer, { GlobalStyles } from "../components/MainContainer";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";
import StylesContext from "../context/StylesContext";
import StyledContainer from "../components/StyledContainer";
import { useLanguage, useNoPCD } from "../hooks/languageService";
import VocalInterfaceContext from '../context/VocalInterfaceContext';
import ButtonLangOption from "../components/ButtonLangOption";
import Footer from "../components/Footer";
import VideoContext from "../context/VideoContext";

function LanguageList() {
  const { styles, setStyles } = useContext(StylesContext);
  const history = useNavigate();

  const { menu } = useParams<{ menu: string }>();
  const { setIsVideo } = useContext(VideoContext);

  const { setLanguage } = useLanguage();

  const { setNoPCD  } = useNoPCD();
  // const  { setIsVocalInterface, isChart,  setIsAdButtonClicked } = useContext(VocalInterfaceContext);
  
  useEffect(() => {
    const getStyles = async () => {
      try {
        const { data } = await api.get(`menu_styles/${menu}`);
        setStyles(data);
      } catch (error: any) {
        console.error(error.message);
      }
    };
    getStyles();
  }, [menu]);

  const handleLanguageChange = (languageCode: string) => {
    setLanguage(languageCode);
    // setIsAdButtonClicked(true);
    // setIsVocalInterface(true);
    setNoPCD(true);
    history(`/cardapio/${styles.urlId}/categories`);
  }
  return (
    <MainContainer
      className="languages_main_container"
      $backgroundColor={styles?.bgColor}
    >
      <GlobalStyles $backgroundColor={styles?.bgColor}/>
      <StyledContainer className="lang_page_container">
        <MainLogoContainer
          wrapperClass="logo_home_wrapper"
          logoClass="logo_home"
        />
        <StyledContainer className="button_wrapper">
         <ButtonLangOption
            color={styles?.btnCircleColor}
            className="lang_button"
            flagName="br-flag" 
            langName="Português"
            languageCode="pt-BR"
            onClickFunc={handleLanguageChange}
          />
          <ButtonLangOption
            color={styles?.btnCircleColor}
            className="lang_button"
            flagName="us-flag" 
            langName="English"
            languageCode="en-US"
            onClickFunc={handleLanguageChange} />
          <ButtonLangOption
            color={styles?.btnCircleColor}
            className="lang_button"
            flagName="es-flag" 
            langName="Español"
            languageCode="es-ES"
            onClickFunc={handleLanguageChange} />
        </StyledContainer>
      </StyledContainer>
      <Footer $footerLogoColor={styles.footerColor} />
      
    </MainContainer>
  );
}

export default LanguageList;
